import {
  useHasOrders,
  useHasSession,
} from "@/shared/hooks/usePosOrderTableSessionHook";
import PosSessionCart from "./PosSessionCart";
import PosCartTop from "./PosCartTop";

const PosCartBody = () => {
  const hasOrders = useHasOrders();
  const hasSession = useHasSession();

  return (
    <div className="h-auto overflow-x-hidden rounded-md bg-white">
      <div>{hasOrders && hasSession ? <PosSessionCart /> : <PosCartTop />}</div>
    </div>
  );
};

export default PosCartBody;
